import { BarChart } from '@/components/charts/BarChart';
import { getRandom } from '@/sections/insights/metrics/utils/dateUtils';

function BaseComponent({
  data,
  miniVersion,
}: {
  data: {
    name: string;
    'Open Critical': string | number;
    'Open High': string | number;
    'Open Medium': string | number;
    'Open Low': string | number;
    'Open Info': string | number;
    'Remediated Critical': number;
    'Remediated High': number;
    'Remediated Medium': number;
    'Remediated Low': number;
    'Remediated Info': number;
  }[];
  miniVersion?: boolean;
}) {
  return (
    <BarChart
      data={data}
      lines={[
        {
          datakey: 'Open Info',
          lineClassName: 'fill-chariot-stroke-info text-chariot-stroke-info',
        },
        {
          datakey: 'Open Low',
          lineClassName: 'fill-chariot-stroke-low text-chariot-stroke-low',
        },
        {
          datakey: 'Open Medium',
          lineClassName:
            'fill-chariot-stroke-medium text-chariot-stroke-medium',
        },
        {
          datakey: 'Open High',
          lineClassName: 'fill-chariot-stroke-high text-chariot-stroke-high',
        },
        {
          datakey: 'Open Critical',
          lineClassName:
            'fill-chariot-stroke-critical text-chariot-stroke-critical',
        },

        {
          datakey: 'Remediated Info',
          lineClassName: 'fill-chariot-stroke-info text-chariot-stroke-info',
        },
        {
          datakey: 'Remediated Low',
          lineClassName: 'fill-chariot-stroke-low text-chariot-stroke-low',
        },
        {
          datakey: 'Remediated Medium',
          lineClassName:
            'fill-chariot-stroke-medium text-chariot-stroke-medium',
        },
        {
          datakey: 'Remediated High',
          lineClassName: 'fill-chariot-stroke-high text-chariot-stroke-high',
        },
        {
          datakey: 'Remediated Critical',
          lineClassName:
            'fill-chariot-stroke-critical text-chariot-stroke-critical',
        },
      ]}
      labelBottom={miniVersion ? undefined : 'Remediations'}
      labelTop={miniVersion ? undefined : 'New Issues'}
    />
  );
}

const sampleData = [...Array(30).keys()].map(i => {
  if (i < 2) {
    return {
      name: `Jan ${i + 1}`,
      'Open Critical': 0,
      'Open High': 0,
      'Open Medium': 0,
      'Open Low': 0,
      'Open Info': 0,

      'Remediated High': 0,
      'Remediated Medium': 0,
      'Remediated Low': 0,
      'Remediated Info': 0,
      'Remediated Critical': 0,
    };
  }

  if (i % 2 === 0) {
    return {
      name: `Jan ${i + 1}`,
      'Open Critical': getRandom(),
      'Open High': getRandom(),
      'Open Medium': getRandom(),
      'Open Low': getRandom(),
      'Open Info': getRandom(),

      'Remediated High': 0,
      'Remediated Medium': 0,
      'Remediated Low': 0,
      'Remediated Info': 0,
      'Remediated Critical': 0,
    };
  }
  return {
    name: `Jan ${i + 1}`,
    'Open Critical': 0,
    'Open High': 0,
    'Open Medium': 0,
    'Open Low': 0,
    'Open Info': 0,

    'Remediated Critical': getRandom(30) * -1,
    'Remediated High': getRandom(10) * -1,
    'Remediated Medium': getRandom(3) * -1,
    'Remediated Low': getRandom(3) * -1,
    'Remediated Info': getRandom(20) * -1,
  };
});

export function VulnerabilityOverviewExample() {
  return <BaseComponent data={sampleData} miniVersion />;
}
